/* eslint-disable @next/next/no-img-element */
import {
  DataProvider,
  PlasmicCanvasContext,
  usePlasmicQueryData,
  useSelector,
} from "@plasmicapp/loader-nextjs";
import React, { useContext } from "react";
import { useRouter } from "next/router";

export default function HomePageCatalog(props) {
  const { children, className } = props;

  // Salé et sucré IDs
  const excludedCategoryIds = [44, 39];

  // fresh categories IDs
  const freshTags = ["fresh_product_V1", "fresh"];

  const weeklyPotagerId = "Potager de la semaine";

  const groceryNature = "grocery";

  function shouldNotExcludeCategory(cat) {
    return !excludedCategoryIds.includes(cat.category.id);
  }

  const isCategoryFresh = (category) => {
    return category.tags?.some((tag) => freshTags.includes(tag));
  };

  const isCategoryWeeklyPotager = (category) => {
    return category.categoryName === weeklyPotagerId;
  };

  const isNotGrocery = (product) => product.nature !== groceryNature;

  const { data, error } = usePlasmicQueryData("categories", async () => {
    const apiUrl = `${process.env.NEXT_PUBLIC_FAIT_MAISON_URL}/categories/products`;
    const resp = await fetch(apiUrl, { cache: "no-store" });
    const fetchedData = await resp.json();

    if (fetchedData) {
      const dataParse = fetchedData.data
        .filter(shouldNotExcludeCategory)
        .sort((catA, catB) => catA.category.rank - catB.category.rank)
        .map((cat) => ({
          categoryName: cat.category.category,
          tags: cat.category?.tags,
          image: cat.category.image,
          products: cat.products,
        }));

      // Transformation pour créer les nouvelles catégories "Grocery" et "Frais"
      const newGroceryProducts = [];
      const newFreshProducts = [];
      const newFruitsAndVegetableProducts = [];

      const seenProductIds = new Set();

      dataParse.forEach((categoryObj) => {
        const filteredProducts = categoryObj.products.filter((product) => {
          if (seenProductIds.has(product.id)) {
            return false;
          }
          seenProductIds.add(product.id);

          return true;
        });

        if (isCategoryWeeklyPotager(categoryObj)) {
          newFruitsAndVegetableProducts.push(...filteredProducts);

          return;
        }

        if (isCategoryFresh(categoryObj)) {
          newFreshProducts.push(...filteredProducts.filter(isNotGrocery));

          return;
        }

        newGroceryProducts.push(...filteredProducts);
      });

      const newCategories = [
        {
          category: "Fruits et légumes",
          products: newFruitsAndVegetableProducts,
        },
        { category: "Produits Frais", products: newFreshProducts },
        { category: "Épicerie", products: newGroceryProducts },
      ];

      const allCategoryName = newCategories.map((cat) => ({
        categoryName: cat.category,
      }));

      return {
        products: newCategories,
        allCategoryName,
      };
    }
  });

  if (error) {
    console.error("Erreur de récupération :", error);
    return null;
  }

  if (!data || data.products.length === 0) {
    return null;
  }

  return (
    <DataProvider
      name="HomePageCatalog"
      data={{
        products: data.products,
        categoryName: data.categoryName,
        allCategoryName: data.allCategoryName,
      }}
      className={className}
    >
      <div className={className}>{children}</div>
    </DataProvider>
  );
}
